import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { KTSVG } from '../../../_metronic/helpers'
import { roleInitialsForApp, roleInitialsForUpdate } from './interfaces/roleClass';
import { addAccountRoleAsync, updateAccountRoleAsync } from './roleSlice'
import { Formik } from 'formik';
import * as yup from 'yup';
import { ShowToast } from '../../../common/Toastr';
import { getValueFromResource } from '../../../common/timeLiveFunction';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import infoSVG from "../../../assets/image/info-SVG.svg";
import { TOOLTIP_STYLE } from '../../../common/TooltipStyle';

const RoleForm = (props: any) => {
    const [disabledCount, setDisabledCount] = useState(0)
     const { t, oncloseModal } = props;
    const dispatch = useAppDispatch();
    const { selectedRecord,roleList, isLoading } = useAppSelector((state) => state.role);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(roleInitialsForApp);
    const defaultFocusRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
           
            Object.keys(roleInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
                
            })
            stateItem.IsDisabled = tempObj.IsDisabled === 'Yes' ? true : false;
            setCurrentFieldsData(stateItem);
        }
        else {
            setCurrentFieldsData(roleInitialsForApp);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }
        calculatedDisabledValue();
 
    }, [selectedRecord])

    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateAccountRoleAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Role Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        else {
            dispatch(addAccountRoleAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Role Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })

        }
        oncloseModal();
    }

    const calculatedDisabledValue = () => {
        if (roleList.length > 0) {
            let index = 0;
            roleList.forEach((value) => {
                if (value.IsDisabled.toString() == 'Yes') {
                    index = index + 1
                }
            });
            setDisabledCount(roleList.length - index);
        }
    }
    return (
        <>
            <Formik
                initialValues={currentFieldsData}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    Role: yup
                        .string()
                        .label
                        (t('Role'))
                        // (getValueFromResource('Role',dispatch, t))
                        .trim()
                        .required
                        (t('Role is required'))
                        // (getValueFromResource('Role is required',dispatch, t))
                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        {isLoading ?
                            <div className="col-md-12">
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                    <span className='spinner-border spinner-border-md ms-2'></span>
                                </span>
                            </div>
                            : <>
                                <div className="modal drawer-overlay" style={{ display: 'block' }} >
                                    <div className="modal-dialog">
                                        <div className="modal-content">
                                            <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                {/* <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ? 
                                                t('Update') : t('Add')} {t('Role')} </h5> */}
                                                <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ?
                                                        //  t('Update')
                                                        getValueFromResource('Update ',dispatch, t)
                                                           :
                                                            // t('Add')}
                                                            getValueFromResource('Add ',dispatch, t)}

                                                            {getValueFromResource('Role', dispatch, t)}
                                                        </h5>
                                                <div
                                                    className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                 
                                                    onClick={oncloseModal}
                                                >
                                                    <KTSVG
                                                        path="/media/icons/duotune/arrows/arr061.svg"
                                                        className="svg-icon svg-icon-1x"
                                                    />
                                                </div>
                                            </div>
                                            <div className="modal-body">
                                                <div className="mb-0">
                                                    <label className="fs-7 fw-normal d-flex align-items-center gap-1">
                                                        {/* {t('Role')} */}
                                                        {getValueFromResource('Role', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource('Define a role that groups permissions and controls what users can access within the system.', dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal mt-2"
                                                        id='Role'
                                                        name='Role'
                                                        value={values.Role}
                                                         style={{ color: '#172b4d' }}
                                                        onChange={handleChange('Role')}                                                      
                                                        ref={defaultFocusRef}
                                                    
                                                    />
                                                </div>
                                                <div style={{ paddingRight: 5 }}>
                                                    {touched.Role && errors.Role &&
                                                        <p className='errorMsg'>{errors.Role as string}</p>
                                                    }
                                                </div>
                                                <div className="mb-3 mt-3">
                                                    <label className="fs-7 fw-normal mt-2 d-flex align-items-center gap-1">
                                                        {/* {t('LDAP Role')} */}
                                                        {getValueFromResource('LDAP Role', dispatch, t)}
                                                        <div
                                                            style={{ marginBottom: "2px" }}
                                                            data-tooltip-id="tooltip-description"
                                                            data-tooltip-content={getValueFromResource('Warning: This role is synchronized with your LDAP/Active Directory configuration. Changing it may affect user authentication and access permissions. Modify only if you understand the impact.', dispatch, t)}
                                                        >
                                                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                        </div>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal mt-2"
                                                        id='LDAPRole'
                                                        value={values.LDAPRole}
                                                        onChange={handleChange('LDAPRole')}
                                                        style={{ color: '#172b4d' }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                e.preventDefault();
                                                                setFieldTouched('LDAPRole', true);
                                                                handleSubmit();
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                {Object.keys(selectedRecord).length > 0 ? (
                                                                    disabledCount !== 1 ? <div className="mb-3" >
                                                                        <label className="fs-7 fw-normal mt-2">
                                                                            {/* {t('Disabled')} */}
                                                                            {getValueFromResource('Disabled',dispatch, t)}

                                                                            </label>
                                                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                            <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                                onChange={handleChange('IsDisabled')}
                                                                            />
                                                                        </div>
                                                                    </div> : roleList.find(x => x.AccountRoleId === values.AccountRoleId)?.IsDisabled.toString() === "Yes" && (<div className="mb-3" >
                                                                        <label className="fs-7 fw-normal mt-2">
                                                                            {/* {t('Disabled')} */}
                                                                            {getValueFromResource('Disabled',dispatch, t)}

                                                                            </label>
                                                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                            <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                                onChange={handleChange('IsDisabled')}
                                                                            />
                                                                        </div>
                                                                    </div>)
                                                                ) : null}
                                            </div>
                                            <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                                    onClick={oncloseModal}
                                                >
                                                    {/* {t('Cancel')} */}
                                                    {getValueFromResource('Cancel',dispatch, t)}

                                                </button>
                                                <button type="button" className="btn btn-primary btn-bs-btn-font-weight btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
                                                {/* {t('Save')} */}
                                                {getValueFromResource('Save',dispatch, t)}

                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </Fragment>
                )}</Formik>
            <ReactTooltip
                id="tooltip-description"
                style={TOOLTIP_STYLE}
                place="top"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
        </>
    )
}

export default RoleForm;